

const newCategories = [
  {
    title: "MAKE UP",
    filter: {Categoria:'make up'},
    categories: [
      {
        name: "LABIOS",
        filter: {Subcategoria:"labios"},
        subcategories: [
          {label:"Delineadores",filter:{Subcategoria:"delineadores"}},
          {label:"Labiales & brillos",filter:{Subcategoria:"labiales y Brillos de labios"}},
        ],
      },
      {
        name: "OJOS",
        filter: {Subcategoria:"ojos"},
        subcategories: [
          {label:"Cejas & pestañas",filter:{Subcategoria:"cejas y pestañas"}},
          {label:"Delineadores",filter:{Subcategoria:"delineadores"}},
          {label:"Sombras de ojos",filter:{Subcategoria:"sombras de ojos"}},
        ],
      },

      {
        name: "ROSTRO",
        filter: {Subcategoria:"rostro"},
        subcategories: [
          {label:"Bases de maquillaje",filter:{Subcategoria:"bases de maquillaje"}},
          {label:"Correctores",filter:{Subcategoria:"correctores"}},
          {label:"Rubores",filter:{Subcategoria:"rubores"}},
          {label:"Iluminadores",filter:{Subcategoria:"iluminadores"}},
          {label:"Bronzer",filter:{Subcategoria:"bronzer"}},
          {label:"Fijadores",filter:{Subcategoria:"fijadores"}},
        ],
      },
      
      {
        name: "ACCESORIOS",
        filter: {Subcategoria:"accesorios"},
        subcategories: [
          { label: "Brochas", filter: {Termino:"brocha"} },
          { label: "Esponjas", filter: {Subcategoria:"esponjas"} },
        ],
      },
      {
        name: "Ver todo",
        filter: {Categoria:"make up"},
        subcategories: [
        ],
      },
    ],
  },
  {
    title: "SKIN CARE",
    filter: {Categoria:"skin care"},
    categories: [
      {
        name: "ROSTRO",
        filter:  {Subcategoria:"rostro"},
        subcategories: [
          { label: "Hidratación", filter: {Subcategoria:"hidratacion"} },
          { label: "Linea teen", filter: {Subcategoria:"linea teen"} },
          { label: "Limpieza", filter: {Subcategoria:"limpieza"} },
          { label: "Tratamientos", filter: {Subcategoria:"tratamientos"} },
        ],
      },
      {
        name: "CUERPO",
        filter:  {Subcategoria:"cuerpo"},
        subcategories: [
          { label: "Cremas", filter: {Subcategoria:"cremas"} },
        ],
      },
      {
        name: "ACCESORIOS SKIN CARE",
        filter:  {Subcategoria:"accesorios", Categoria:"skin care"},
        subcategories: [
          { label: "Esponjas", filter: {Subcategoria:"esponjas", Categoria:"skin care"} },
          { label: "Facial", filter: {Subcategoria:"facial", Categoria:"skin care"} },
          { label: "Corporal", filter: {Subcategoria:"corporal", Categoria:"skin care"} },
        ],
      },
      {
        name: "Ver todo",
        filter: {Categoria:"skin care"},
        subcategories: [
        ],
      },
    ],
  },
  {
    title: "NAILS",
    filter: {Categoria:"nails"} ,
    categories: [
      {
        name: "ESMALTES",
        filter: {Subcategoria:"esmaltes", Categoria:"nails"},
        subcategories: [
          { label: "Tradicional", filter: {Subcategoria:"tradicional", Categoria:"nails"} },
          { label: "Semipermante", filter: {Subcategoria:"semipermanente", Categoria:"nails"} },
          { label: "Tratamientos", filter: {Subcategoria:"tratamientos", Categoria:"nails"} },
        ],
      },
      {
        name: "HERRAMIENTAS",
        filter: {Subcategoria:"Herramientas"},
        subcategories: [
        ],
      },
      {
        name: "NAIL ART",
        filter: {Subcategoria:"nail art", Categoria:"nails"},
        subcategories: [
          { label: "Apliques", filter: {Subcategoria:"apliques", Categoria:"nails"} },
          { label: "Polvos chrome", filter: {Subcategoria:"polvos chrome", Categoria:"nails"} },
        ],
      },
    ],
  },
  {
    title: "BOXES",
    filter: {Categoria:"boxes"} ,
    categories: [
      {
        name: "MAKE UP",
        filter: {Subcategoria:"make up", Categoria:"boxes"},
        subcategories: [],
      },
      {
        name: "SKIN CARE",
        filter: {Subcategoria:"skin care", Categoria:"boxes"},
        subcategories: [],
      },
      {
        name: "MINI BEAUTIQUERAS",
        filter: {Subcategoria:"mini beautiqueras", Categoria:"boxes"},
        subcategories: [],
      },
    ],
  },
  {
    title: "MINI BEAUTIQUERAS",
    filter: {Categoria:"mini beautiqueras"},
    categories: [
      {
        name: "MAKE UP",
        filter: {Categoria:"mini beautiqueras", Subcategoria:"make up"},
        subcategories: [
          { label: "Labios", filter: {Categoria:"mini beautiqueras", Subcategoria:"labios"} },
          { label: "Ojos", filter: {Categoria:"mini beautiqueras", Subcategoria:"ojos"} },
          { label: "Rostro", filter: {Categoria:"mini beautiqueras", Subcategoria:"rostro"} },
        ],
      },
    
      {
        name: "ACCESORIOS",
        filter: {},
        subcategories: [
          { label: "Para el Pelo", filter: {Categoria:"mini beautiqueras", Subcategoria:"pelo"} },
          { label: "Para Skin Care", filter: {Categoria:"mini beautiqueras", Subcategoria:"skin care"} },
          { label: "Para Make Up", filter: {Categoria:"mini beautiqueras", Subcategoria:"make up"} },
          { label: "Fashion", filter: {Termino:"Fashion"} },
        ],
      },
      {
        name: "BOXES",
        filter: {Categoria:"mini beautiqueras", Subcategoria:"boxes"},
        subcategories: [

        ],
      },
      {
        name: "Ver todo",
        filter: {Categoria:"mini beautiqueras"},
        subcategories: [],
      },
    ],
  },
  {
    title: "PARA REGALAR",
    filter: {Categoria:"para regalar"},
    categories: [
      {
        name: "COMBOS",
        filter: {Categoria:"para regalar", Subcategoria:"combos"},
        subcategories: [],
      },
      {
        name: "TOTEBAGS",
        filter: {Categoria:"para regalar", Subcategoria:"totebags"},
        subcategories: [],
      },
      {
        name: "BEAUTI HOME",
        filter: {Categoria:"para regalar", Subcategoria:"beautihome"},
        subcategories: [],
      },
      {
        name: "GIFT CARDS",
        filter:{Subcategoria:"gift cards"} ,
        subcategories: [],
      },
      {
        name: "Ver todo",
        filter: {Categoria:"para regalar"},
        subcategories: [],
      },
    ],
  },
  {
    title: "BEAUTI GANGAS",
        filter: {},
    categories: [
        {
        name: "VER BEAUTI GANGAS",
        filter:{Categoria:"Gangas"} ,
        subcategories: [],
      },
    ],
  },
  {
    title: "MARCAS",
    marcasArray:["A2", "BUNIBLISS", "CALLISTA", "CITY GIRL", "ESSENCE", "HUDA BEAUTY", "IBD", "ICONSIGN", "IDI", "JUKA", "KIKI","KIKO", "LA BEAUTIQUERIA", "LACA", "MELY", "MISS LARA", "NAVI", "NOTE", "OPI", "ORLY", "PARIS NIGHT","PINK 21", "RUBY FACE", "SAVIA TIERRA", "SEPHORA","SRI SRI", "SUN", "TEI", "USHAS","VICTORIA'S SECRET","WYCON", "XULU" ],
    filter: {},

    categories: [],
  },
  // {
  //   title: "2X1",
  //       filter: {Subcategoria:"2x1"},
  //   categories: [
  //       {
  //       name: "Ver todo",
  //       filter:{Subcategoria:"2x1"} ,
  //       subcategories: [],
  //     },
  //   ],
  // },
];

export default newCategories;
